// @flow

import React from 'react';

import { WhitePanel } from '../../../components';
import { useSelector } from '../../../redux/reduxDB';
import { deleteOrder } from '../../../services/cart';
import { getOrderByIdAndType, updateCart } from '../../../redux/cart';
import { provideIcon, getDiffInDays } from '../../Lodge/helpers';
import {  formatToShow, padSAtTheEndIfPlural } from '../../../lib/helpers';

import type { LodgeOrderType } from './index';
import config from '../../../config';
import { getCustomToast } from '../../../components/ErrorMessage';


type Props = {
  orderId: string,
  shouldShowDelete?: boolean,
};

export default function Order(props: Props) {
  const { orderId, shouldShowDelete = false } = props;
  const lodgeOrder: LodgeOrderType | null = useSelector(getOrderByIdAndType, [orderId, 'lodge']);

  if (!lodgeOrder) return null;

  const { itemData, invoiceId } = lodgeOrder;
  const {
    checkinDate,
    checkoutDate,
    pax,
    totalAmount,
    currency,
    lodge: { name, address, coverImages },
    roomType,
  } = itemData;
  let { lodge: { services } } = itemData;

  // Remove breakfast filter in new update
  // services = services.filter(s => s && s.toLowerCase() !== 'breakfast');

  const formattedCheckin = formatToShow(checkinDate);
  const formattedCheckout = formatToShow(checkoutDate);

  const numNights = getDiffInDays(checkinDate, checkoutDate);

  const [isDeleting, setIsDeleting] = React.useState(false);

  const DetailList = (
    <ul className="detail-list">
      <Item title="Checkin-Date" value={formattedCheckin} />
      <Item title="Night Stay" value={`${numNights} ${padSAtTheEndIfPlural(numNights, 'Night')}`} />
      <Item title="Room Type" value={roomType} />
      <Item title="No. of Trekkers" value={`${pax} ${padSAtTheEndIfPlural(pax, 'Trekker')}`} />
    </ul>
  );

  const onDelete = React.useCallback(async (e) => {
    e.preventDefault();
    
    setIsDeleting(true);
    try {
      const newCartData = await deleteOrder(orderId, invoiceId);
      updateCart(newCartData);
    } catch (err) {
      getCustomToast(
        'There seems to a problem while deleting your order. Please try again',
        'error'
      );
    } finally { 
      setIsDeleting(false);
    }
  }, [orderId, invoiceId]);

  const totalPrice = totalAmount.toLocaleString();

  return (
    <React.Fragment>
      <div className="cart-item" style={{ opacity: isDeleting ? 0.5 : 1  }}>
        <span className="date">{formattedCheckin} - {formattedCheckout}</span>
        {shouldShowDelete &&
          <span className="pr-2 float-right">
            <a onClick={onDelete}>Delete item</a>
          </span>}
        <WhitePanel>
          <div className="cart-item-detail">
            <div className="item-image" style={{ backgroundImage: `url(${config.RESOURCE_URL}/${coverImages.medium})` }}>
              <img src={`${config.RESOURCE_URL}/${coverImages.medium}`} alt={name} />
            </div>
            <div className="item-details">
              <div className="item-detail-left">
                <h5>
                  {name}, {address}
                </h5>
                <div className="service-holder">
                  {services.map(service => (
                    <span key={service}>
                      <i className={provideIcon(service)} /> {service}
                    </span>
                  ))}
                </div>
              </div>
              <div className="item-detail-right">
                <p>
                  {currency} {totalPrice.toLocaleString()}
                </p>
              </div>
              <div className="item-detail-left fullwrap">
                {DetailList}
              </div>
            </div>
          </div>
        </WhitePanel>
      </div>
    </React.Fragment>
  );
}

const Item = ({ title, value }: { title: string, value: string | number }) => (
  <li>
    <div className="dt-title">{title}</div>
    <div className="dt-detail">{value}</div>
  </li>
);



// WEBPACK FOOTER //
// ./src/screens/Cart/Common/Order.js